import { render, staticRenderFns } from "./allGoodsAssess.vue?vue&type=template&id=f6adb7d8&scoped=true"
import script from "./allGoodsAssess.vue?vue&type=script&lang=js"
export * from "./allGoodsAssess.vue?vue&type=script&lang=js"
import style0 from "./allGoodsAssess.vue?vue&type=style&index=0&id=f6adb7d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6adb7d8",
  null
  
)

export default component.exports